<div class="opf-slot">
  <button type="button" class="op-filterbtn" (click)="opened = true; statusOpen = false">
    <i class="material-icons">filter_list</i> {{ constants.LABELS.FILTER }}
  </button>
  <div class="op-filter-backdrop" *ngIf="opened" (click)="opened = false"></div>
  <div class="op-filter-panel" *ngIf="opened">
    <div class="op-fp-head">{{ constants.LABELS.FILTER }}</div>
    <ng-container *ngIf="openForm && showForm">
      <form [formGroup]="filterForm">
        <div class="op-fp-row">
          <label class="op-fp-label">{{ constants.LABELS.JOB_TITLE }}</label>
          <select class="op-fp-field" formControlName="selectedJobtitle">
            <option [ngValue]="null">All</option>
            <option *ngFor="let o of jobTitle" [ngValue]="o.value">{{ o.label }}</option>
          </select>
        </div>
        <div class="op-fp-row">
          <label class="op-fp-label">{{ constants.LABELS.LOB }}</label>
          <select class="op-fp-field" formControlName="selectedLob">
            <option [ngValue]="null">All</option>
            <option *ngFor="let o of lob" [ngValue]="o.value">{{ o.label }}</option>
          </select>
        </div>
        <div class="op-fp-row" *ngIf="isVendorOrOpsVisible()">
          <label class="op-fp-label">{{ constants.LABELS.ID_T_LEADER }}</label>
          <select class="op-fp-field" formControlName="selectedLeader">
            <option [ngValue]="null">All</option>
            <option *ngFor="let o of leader" [ngValue]="o.value">{{ o.label }}</option>
          </select>
        </div>
        <div class="op-fp-row" *ngIf="isVendorOrOpsVisible()">
          <label class="op-fp-label">{{ constants.LABELS.OPENED_DATE }}</label>
          <input type="date" class="op-fp-field" formControlName="selectedRaisedOn" />
        </div>
        <div class="op-fp-row">
          <label class="op-fp-label">{{ constants.LABELS.DESIRED_START_DATE }}</label>
          <input type="date" class="op-fp-field" formControlName="selectedStartdate" />
        </div>
        <div class="op-fp-row" *ngIf="isVendorOrOpsVisible()">
          <label class="op-fp-label">{{ constants.LABELS.LOCATION }}</label>
          <select class="op-fp-field" formControlName="selectedLocation">
            <option [ngValue]="null">All</option>
            <option *ngFor="let o of location" [ngValue]="o.value">{{ o.label }}</option>
          </select>
        </div>
        <div class="op-fp-row" *ngIf="isHireMgrOrOpsVisible()">
          <label class="op-fp-label">{{ constants.LABELS.SELECT_VENDOR }}</label>
          <select class="op-fp-field" formControlName="selectedSharedByVendor">
            <option [ngValue]="null">All</option>
            <option *ngFor="let o of sharedByVendor" [ngValue]="o.value">{{ o.label }}</option>
          </select>
        </div>
        <div class="op-fp-row">
          <label class="op-fp-label">{{ constants.LABELS.STATUS }}</label>
          <div class="op-fp-msel">
            <button type="button" class="op-fp-field op-fp-msel-btn" (click)="statusOpen = !statusOpen">
              <span class="msel-text">{{ statusSummary }}</span>
              <i class="material-icons" [class.flip]="statusOpen">expand_more</i>
            </button>
            <div class="op-fp-msel-list" *ngIf="statusOpen">
              <label class="op-fp-check" *ngFor="let s of requestStatus">
                <input type="checkbox" [checked]="isStatusChecked(s.value)" (change)="toggleStatus(s.value)" />
                {{ s.label }}
              </label>
            </div>
          </div>
        </div>
      </form>
    </ng-container>
    <div class="op-fp-actions">
      <button type="button" class="op-fp-reset" (click)="statusOpen = false; reset()">{{ constants.LABELS.RESET }}</button>
      <button type="button" class="op-fp-apply" (click)="statusOpen = false; opened = false; apply()">{{ constants.LABELS.APPLY }}</button>
    </div>
  </div>
</div>
